import { useMemo } from 'react';
import { useFetchUserInfo } from './useFetchUserInfo';
export const useLimit = limit => {
  const userInfoResult = useFetchUserInfo();
  return useMemo(() => Object.assign({}, userInfoResult, {
    data: userInfoResult.data && userInfoResult.data.userInfo.portal.limits[limit]
  }), [limit, userInfoResult]);
};